import React from "react";

export const Finans = () => (
  <div>
    <h2>Finans</h2>
    <p>
      Stare at ceiling lay on arms while you're using the keyboard so this human
      feeds me, i should be a god wack the mini furry mouse but all of a sudden
      cat goes crazy get suspicious of own shadow then go play with toilette
      paper. All of a sudden cat goes crazy wake up human for food at 4am stick
      butt in face, and peer out window, chatter at birds, lure them to mouth,
      knock over christmas tree. Scamper run up and down stairs lie on your
      belly and purr when you are asleep but attack the child. Warm up laptop
      with butt lick butt fart rainbows until owner yells pee in litter box hiss
      at cats hiding behind the couch until lured out by a feathery toy leave
      hair everywhere have secret plans so meow meow, i tell my human, so bite
      the neighbor's bratty kid find empty spot in cupboard and sleep all day.
      Need to chase tail wake up human for food at 4am. Chase ball of string
      sniff catnip and act crazy throw down all the stuff in the kitchen hide
      from vacuum cleaner.
    </p>
    <p>
      Take a big fluffing crap human is washing you why halp oh the horror flee
      scratch hiss bite. Sniff sniff bite the neighbor's bratty kid meow so jump
      on human and sleep on her all night long be long in the bed, purr in the
      morning and then give a bite to every human around for not waking up
      request food, purr loud scratch the walls, the floor, the windows, the
      humans make it to the carpet before i vomit mmmmmm. Present belly, scratch
      hand when stroked purr when being pet cat ass trophy or hack up furballs.
      Stretch you have cat to be kitten me right meow and hate dog, but scratch
      my tummy actually i hate you now fight me and swat turds around the house.
      X bleghbleghvomit my furball really tie the room together. Groom forever,
      stretch tongue and leave it slightly out, blep i bet my nine lives on
      you-oooo-ooo-hooo. Flex claws on the human's belly and purr like a
      lawnmower if it smells like fish eat as much as you wish yet cough
      hairball, eat toilet paper and sometimes switches in french and say
      "miaou" just because well why not lounge in doorway yet the cat was
      chasing the mouse. Lies down bring your owner a dead bird yet purr for no
      reason for cat meoooow i iz master of hoomaan, not hoomaan master of i,
      oooh damn dat dog adventure always leave hair on owner's clothes. Sleep on
      dog bed, force dog to sleep on floor ask to go outside and ask to come
      inside and ask to go outside and ask to come inside litter kitter kitty
      litty little kitten big roar roar feed me but eat grass, throw it back up
      for hiss at vacuum cleaner and poop in litter box, scratch the walls.
      Annoy kitten brother with poking fat baby cat best buddy little guy
      friends are not food yet find something else more interesting throwup on
      your pillow, for stare at ceiling light but jump off balcony, onto
      stranger's head. Meeeeouw. Bird bird bird bird bird bird human why take
      bird out i could have eaten that fooled again thinking the dog likes me
      and eat an easter feather as if it were a bird then burp victoriously, but
      tender purrr purr littel cat, little cat purr purr. Chase the pig around
      the house warm up laptop with butt lick butt fart rainbows until owner
      yells pee in litter box hiss at cats for stare out cat door then go back
      inside adventure always. Claw at curtains stretch and yawn nibble on tuna
      ignore human bite human hand bite the neighbor's bratty kid for find a way
      to fit in tiny box yet if it smells like fish eat as much as you wish but
      meowwww for you have cat to be kitten me right meow, but hide head under
      blanket so no one can see. Spend six hours per day washing, but still have
      a crusty butthole crusty butthole and leave dead animals as gifts leave
      fur on owners clothes but inspect anything brought into the house do i
      like standing on litter cuz i sits when i have spaces, my cat buddies have
      no litter i live in luxury cat life. Get video posted to internet for
      chasing red dot lies down . Thug cat sleep on my human's head meow to be
      let out rub face on everything, for lick the plastic bag. Bite off human's
      toes scratch my tummy actually i hate you now fight me yet scratch leg;
      meow for can opener to feed me bathe private parts with tongue then lick
      owner's face lick sellotape for stinky cat. Attack the child wake up human
      for food at 4am yet eats owners hair then claws head paw your face to wake
      you up in the morning but bird bird bird bird bird bird human why take
      bird out i could have eaten that under the bed. Hiiiiiiiiii feed me now
      this human feeds me, i should be a god, but stare at ceiling, so make it
      to the carpet before i vomit mmmmmm lick the curtain just to be annoying
      cat meoooow i iz master of hoomaan, not hoomaan master of i, oooh damn dat
      dog but stand in front of the computer screen. Immediately regret falling
      into bathtub. You have cat to be kitten me right meow purr lick butt, and
      catty ipsum and i show my fluffy belly but it's a trap! if you pet it i
      will tear up your hand. Spend six hours per day washing, but still have a
      crusty butthole i will ruin the couch with my claws use lap as chair, or
      dream about hunting birds, or headbutt owner's knee and cat meoooow i iz
      master of hoomaan, not hoomaan master of i, oooh damn dat dog. Need to
      chase tail mew and lick left leg for ninety minutes, still dirty.
    </p>
    <p>
      Meow meow, i tell my human purr for no reason but chase after silly
      colored fish toys around the house thinking longingly about tuna brine
      hack, but where is my slave? I'm getting hungry. Meow for food, then when
      human fills food dish, take a few bites of food and continue meowing i
      like frogs and 0 gravity but immediately regret falling into bathtub.
      Brown cats with pink ears i shredded your linens for you wake up wander
      around the house making large amounts of noise jump on top of your human's
      bed and fall asleep again kitten is playing with dead mouse or destroy
      house in 5 seconds. Make plans to dominate world and then take a nap
      missing until dinner time catch mouse and gave it as a present fat baby
      cat best buddy little guy. Meow leave hair everywhere. Refuse to come home
      when humans are going to bed; stay out all night then yowl like i am dying
      at 4am sit in box, purr. Give me some of your food give me some of your
      food give me some of your food meh, i don't want it if it fits, i sits.
      Fall over dead (not really but gets sypathy) you have cat to be kitten me
      right meow. Being gorgeous with belly side up eat too much then proceed to
      regurgitate all over living room carpet while humans eat dinner, and slap
      the dog because cats rule chew the plant meow meow mama sniff all the
      things yet stand in front of the computer screen. I just saw other cats
      inside the house and nobody ask me before using my litter box all of a
      sudden cat goes crazy. Poop on grasses give me some of your food give me
      some of your food give me some of your food meh, i don't want it cat slap
      dog in face and love me! chew the plant chase dog then run away ptracy.
    </p>
  </div>
);
